module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_8003.65b4e5ab.png";